import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "io-container container-fluid" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IoHeadline = _resolveComponent("IoHeadline")!
  const _component_IoSpacer = _resolveComponent("IoSpacer")!
  const _component_IoText = _resolveComponent("IoText")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["row g-4 g-xl-5 io-eq", `justify-content-${_ctx.align}`])
    }, [
      (_ctx.useHeadline === '1' && ['start', 'end'].indexOf(_ctx.align) >= 0)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["col-12 col-lg-5 col-xl-4 col-xxl-3", _ctx.align === 'end' ? 'order-lg-2' : 'order-lg-0'])
          }, [
            _createVNode(_component_IoHeadline, {
              size: "h2",
              align: _ctx.headlineAlign,
              "text-align": _ctx.headlineAlign
            }, {
              default: _withCtx(() => [
                _renderSlot(_ctx.$slots, "headline")
              ]),
              _: 3
            }, 8, ["align", "text-align"]),
            (_ctx.hasTextContent)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createVNode(_component_IoSpacer, { size: "medium" }),
                  _createVNode(_component_IoText, {
                    align: _ctx.headlineAlign,
                    "text-align": _ctx.headlineAlign
                  }, {
                    default: _withCtx(() => [
                      _renderSlot(_ctx.$slots, "text")
                    ]),
                    _: 3
                  }, 8, ["align", "text-align"])
                ], 64))
              : _createCommentVNode("", true)
          ], 2))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.colClass)
      }, [
        (_ctx.useHeadline === '1' && _ctx.align === 'center')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createVNode(_component_IoHeadline, {
                size: "h2",
                align: _ctx.headlineAlign,
                "text-align": _ctx.headlineAlign
              }, {
                default: _withCtx(() => [
                  _renderSlot(_ctx.$slots, "headline")
                ]),
                _: 3
              }, 8, ["align", "text-align"]),
              _createVNode(_component_IoSpacer, { size: "medium" }),
              (_ctx.hasTextContent)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createVNode(_component_IoText, {
                      align: _ctx.headlineAlign,
                      "text-align": _ctx.headlineAlign
                    }, {
                      default: _withCtx(() => [
                        _renderSlot(_ctx.$slots, "text")
                      ]),
                      _: 3
                    }, 8, ["align", "text-align"]),
                    _createVNode(_component_IoSpacer, { size: "medium" })
                  ], 64))
                : _createCommentVNode("", true)
            ], 64))
          : _createCommentVNode("", true),
        _renderSlot(_ctx.$slots, "default")
      ], 2)
    ], 2)
  ]))
}